/**
 * Jet demandé par le MJ (Realtime DB : rollRequest/{campagne}) : une demande à la fois.
 * Format : {id, mode: 'pool'|'frenzy', traits: [attribut, compétence/attribut], difficulty, hidden, targets: [uid de personnage], createdAt}.
 * Les jets lancés en réponse portent `requestId` : on sait qui a déjà lancé en lisant le chat.
 */
import {getRollLabel} from './rolls';

export const REQUEST_MODES = {POOL: 'pool', FRENZY: 'frenzy'};

export const createRollRequest = ({id, mode = REQUEST_MODES.POOL, traits = [], difficulty = null, hidden = false, targets = [], createdAt = Date.now()}) => ({
  id,
  mode,
  // '' plutôt que null : Realtime DB transformerait le tableau troué en objet
  traits: mode === REQUEST_MODES.FRENZY ? [] : [traits[0] || '', traits[1] || ''],
  difficulty: difficulty ?? null,
  hidden: Boolean(hidden),
  targets,
  createdAt,
});

/** Relit une demande venant de Realtime DB (tableaux vides absents). */
export const normalizeRollRequest = (value) => (value && value.id ? {
  ...value,
  traits: [value.traits?.[0] || '', value.traits?.[1] || ''],
  targets: value.targets || [],
  difficulty: value.difficulty ?? null,
} : null);

/** Jet lancé par ce personnage en réponse à la demande, ou null. */
export const findRequestRoll = (request, characterUid, rolls) => (request
  ? rolls.filter(record => record.requestId === request.id && record.characterId === characterUid).pop() || null
  : null);

/** La demande attend-elle encore un jet de ce personnage ? */
export const isRequestPendingFor = (request, characterUid, rolls) => Boolean(
  request && request.targets.includes(characterUid) && !findRequestRoll(request, characterUid, rolls),
);

/** Tous les personnages visés ont-ils lancé ? */
export const isRequestComplete = (request, rolls) => Boolean(
  request && request.targets.every(characterUid => findRequestRoll(request, characterUid, rolls)),
);

/** « Astuce + Investigation » ; null pour un test de frénésie (libellé traduit par l'appelant). */
export const getRequestLabel = (request, lng = 'fr') => (request.mode === REQUEST_MODES.FRENZY ? null : getRollLabel(request.traits, lng));
